import { Level, UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent, useState } from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { FormError } from '../../ui';
import { getMomentFormat, i18n } from '../../utils';
import { selectSkillLevel } from '../actions';
import {
  BookingFlowFooter, BookingInstructionHeader,
  BookingInstructionSubtitle,
} from '../components';
import { SkillLevelSelection } from '../components';
import { styles as sharedStyles } from './Styles';

export interface IProps {
  userProfile: UserProfile;
  workoutSession: UserWorkoutSession;
  workoutSessionService: any;
  skillLevelLoading: boolean;
  skillLevelError: string | null;
  t(key: string): string;
  getNextBookingStep(): void;
  selectSkillLevel(userProfileService: any, userProfile: UserProfile, skillLevel: Level): void;
}

const SelectSkillLevel: FunctionComponent<IProps> = ({
  t,
  userProfile,
  userProfileService,
  skillLevelLoading,
  skillLevelError,
  selectSkillLevel,
}) => {
  if (skillLevelLoading) {
    return (
      <ActivityIndicator
        size='small'
        animating={true}
        color={Theme.PRIMARY}
        style={styles.loadingContainer}
      />
    );
  }

  const [skillLevel, setSkillLevel] = useState<Level | null>(null);
  return (
    <View style={styles.container}>
      <View style={sharedStyles.body}>
        <BookingInstructionHeader header={t('selectSkillLevelSelection')} />
        <SkillLevelSelection
          skillLevel={skillLevel}
          onPress={setSkillLevel}
        />
        <BookingInstructionSubtitle header={t('adjustsDifficulty')} />
      </View>
      <BookingFlowFooter>
        {skillLevelError && <FormError error={new Error(skillLevelError)} />}
        <Button
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          disabled={!skillLevel}
          title={i18n.t('bookings:continue')}
          onPress={() => selectSkillLevel(userProfileService, userProfile, skillLevel as Level)}
          containerStyle={styles.nextContainer}
        />
      </BookingFlowFooter>
    </View>
  );
};

const mapStateToProps = (state): Partial<IProps> => {
  return {
    skillLevelLoading: state.bookings.bookingWizard.skillLevelLoading,
    skillLevelError: state.bookings.bookingWizard.skillLevelError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectSkillLevel: (userProfileService, userProfile, skillLevel) =>
      dispatch(selectSkillLevel(userProfileService, userProfile, skillLevel)),
  };
};

export const SkillLevelSelectionStep = connect(mapStateToProps, mapDispatchToProps)(
  translate(['bookings', 'common'], { wait: true })(SelectSkillLevel));

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  nextContainer: {
  },
});
